var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000046",
    d: "M6.275 22.015q-.959 0-1.612-.653-.654-.654-.653-1.612V7.94q0-.338.243-.581a.8.8 0 0 1 .582-.244q.338 0 .581.244a.8.8 0 0 1 .244.581v11.81q0 .231.192.423.193.192.423.192h8.76q.338 0 .581.244a.8.8 0 0 1 .244.581q0 .339-.244.582a.8.8 0 0 1-.582.243zm4.3-4.3q-.959 0-1.612-.653-.653-.654-.653-1.612V4.48q0-.958.653-1.611.654-.654 1.612-.654h7.92q.957 0 1.611.654.653.653.653 1.612V15.45q0 .958-.653 1.612-.654.653-1.612.653zm0-1.65h7.92a.59.59 0 0 0 .422-.192.59.59 0 0 0 .192-.423V4.48a.59.59 0 0 0-.192-.422.59.59 0 0 0-.423-.193h-7.92a.59.59 0 0 0-.422.193.59.59 0 0 0-.192.423V15.45q0 .231.192.423.193.192.423.192"
  })));
};
export default SvgCopy;